import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  conta: '',
  descricao: '',
  tipo: [],
  ativo: null,
};

export const ContasContext = createContext();

export const ContasProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [contas, setContas] = useState({
    data: [],
    colunas: [],
    order: { field: 'conta', sort: 'asc' },
    filter,
    page: 0,
    size: 10,
  });

  const getContas = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: contas?.filter,
        page: contas?.page,
        size: contas?.size,
        order: contas?.order,
        ...payload,
      });
      setContas((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postConta = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post(`/Financeiro/Lancamentos/Contas`, data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <ContasContext.Provider
      value={{
        getLoading,
        getContas,
        contas,
        postConta,
        postLoading,
      }}
    >
      {children}
    </ContasContext.Provider>
  );
};
